<div class="m-b-10" fxLayout="row" fxLayoutAlign="space-between center">
  <div fxLayoutAlign="start start" fxLayout="column" fxLayout.lt-sm="column">
    <span style="font-size: xx-large;">{{ releaseIssueId ? 'Edit' : 'Add' }} Release Issue</span>
    <small *ngIf="releaseIssueId && releaseIssue?.dateUpdated">Updated <span class="text-info">{{ releaseIssue?.dateUpdated | date:'short' }}</span> by <i class="text-success">{{ releaseIssue?.updatedByName }}</i></small>
    <small *ngIf="releaseIssueId && !releaseIssue?.dateUpdated">Created <span class="text-info">{{ releaseIssue?.dateCreated | date:'short' }}</span> by <i class="text-success">{{ releaseIssue?.createdByName }}</i></small>
    <small *ngIf="!releaseIssueId">Created <span class="text-info">{{ currentDate | date:'short' }}</span> by <i class="text-success">{{ currentUser }}</i></small>
  </div>
  <mat-icon class="link" (click)="closeDialog()">close</mat-icon>
</div>

<!-- existing issue confirmation -->
<ng-container *ngIf="!confirmedNewIssue">
  <mat-card *ngIf="!selectedCard" class="w-100 contrast mat-card-inline-sm banner-incomplete">
    <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
      <div fxFlex="100" fxLayoutAlign="space-between center" fxLayout="row">
        <span>Does this issue already exist?</span>
        <strong class="link text-success" (click)="confirmedNewIssue = true">Create new issue</strong>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="selectedCard" class="w-100 contrast mat-card-inline-sm banner-info">
    <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
      <div fxFlex="100" fxLayoutAlign="space-between center" fxLayout="row">
        <span>Existing issue selected</span>
        <strong class="link text-success" (click)="addToReleaseIssue()">Link home configuration to issue</strong>
      </div>
    </mat-card-content>
  </mat-card>
  <ng-container>
    <release-issue-list [companyId]="data.companyId" [isSelectable]="true" (onSelectClick)="onCardSelectClick($event)"></release-issue-list>
  </ng-container>
</ng-container>
<!-- existing issue confirmation -->

<ng-container *ngIf="confirmedNewIssue">
  <!-- title and description editing -->
  <div *ngIf="!isTitleEditMode; else editTitleMode">
    <mat-card *ngIf="releaseIssue?.title" class="w-100 contrast mat-card-inline-sm banner-info">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <div fxFlex="100" fxLayoutAlign="space-between center" fxLayout="row">
          <small class="text-info">{{ releaseIssue.title }}</small>
          <mat-icon matTooltip="Edit Title" (click)="isTitleEditMode = true">edit</mat-icon>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <ng-template #editTitleMode>
    <mat-card class="w-100 contrast mat-card-inline-sm banner-incomplete">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <div fxFlex="100" fxLayoutAlign="space-between center" fxLayout="row">
          <mat-form-field class="example-full-width" appearance="legacy">
            <mat-label>{{ releaseIssueId ? 'Edit' : 'Add' }} Title</mat-label>
            <input matInput [(ngModel)]="releaseIssue.title" placeholder="Enter title" (keydown.enter)="isTitleEditMode = false; saveTitle()">
            <mat-icon matSuffix matTooltip="Save" (click)="isTitleEditMode = false; saveTitle()">save</mat-icon>
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-template>
  <div *ngIf="!isDescriptionEditMode; else editDescriptionMode">
    <mat-card *ngIf="releaseIssue?.description" class="w-100 contrast mat-card-inline-sm banner-info">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <div fxFlex="100" fxLayoutAlign="space-between center" fxLayout="row">
          <small>{{ releaseIssue.description }}</small>
          <mat-icon matTooltip="{{ releaseIssueId ? 'Edit' : 'Add' }} Description" (click)="isDescriptionEditMode = true">edit</mat-icon>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <ng-template #editDescriptionMode>
    <mat-card class="w-100 contrast mat-card-inline-sm banner-incomplete">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <div fxFlex="100" fxLayoutAlign="space-between center" fxLayout="row">
          <mat-form-field class="example-full-width" appearance="legacy">
            <mat-label>{{ releaseIssueId ? 'Edit' : 'Add' }} Description</mat-label>
            <textarea matInput [(ngModel)]="releaseIssue.description" placeholder="Enter description" (keydown.enter)="isDescriptionEditMode = false; saveDescription()"></textarea>
            <mat-icon matSuffix matTooltip="Save" (click)="isDescriptionEditMode = false; saveDescription()">save</mat-icon>
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-template>
  <!-- title and description editing -->
  <!-- priority selecting -->
  <ng-container *ngIf="releaseIssue?.title && releaseIssue?.description && !isDescriptionEditMode && !isDescriptionEditMode">
    <mat-card *ngIf="releaseIssue?.releaseIssuePriority == undefined" class="w-100 contrast mat-card-inline-sm banner-incomplete">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
          <strong>Please select a priority to continue</strong>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card *ngIf="releaseIssue?.releaseIssuePriority !== undefined" class="w-100 contrast mat-card-inline-sm banner-info">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <div fxFlex="100" fxLayoutAlign="space-between center" fxLayout="row">
          <strong [class.text-danger]="releaseIssuePriorities.High === releaseIssue?.releaseIssuePriority"
                  [class.text-warning]="releaseIssuePriorities.Medium === releaseIssue?.releaseIssuePriority"
                  [class.text-info]="releaseIssuePriorities.Low === releaseIssue?.releaseIssuePriority">
            {{ getPriority(releaseIssue?.releaseIssuePriority) }}
          </strong>
          <mat-icon matTooltip="Change priority" (click)="releaseIssue.releaseIssuePriority = undefined;">swap_horiz</mat-icon>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card *ngIf="releaseIssue?.releaseIssuePriority === undefined" class="w-100 contrast card-link mat-card-inline-sm" (click)="selectPriority(releaseIssuePriorities.Low)">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
          <strong class="text-info">{{ releaseIssuePriorities[releaseIssuePriorities.Low] }}</strong>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card *ngIf="releaseIssue?.releaseIssuePriority === undefined" class="w-100 contrast card-link mat-card-inline-sm" (click)="selectPriority(releaseIssuePriorities.Medium)">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
          <strong class="text-warning">{{ releaseIssuePriorities[releaseIssuePriorities.Medium] }}</strong>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card *ngIf="releaseIssue?.releaseIssuePriority === undefined" class="w-100 contrast card-link mat-card-inline-sm" (click)="selectPriority(releaseIssuePriorities.High)">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
          <strong class="text-danger">{{ getPriority(releaseIssuePriorities.High) }}</strong>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>
  <!-- priority selecting -->
  <!-- category selecting -->
  <ng-container *ngIf="releaseIssue?.title && releaseIssue?.description && !isDescriptionEditMode && !isDescriptionEditMode">
    <mat-card *ngIf="releaseIssue?.releaseIssueCategory == undefined" class="w-100 contrast mat-card-inline-sm banner-incomplete">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
          <strong>Please select a category to continue</strong>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card *ngIf="releaseIssue?.releaseIssueCategory !== undefined" class="w-100 contrast mat-card-inline-sm banner-info">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <div fxFlex="100" fxLayoutAlign="space-between center" fxLayout="row">
          <strong class="text-info">{{ getCategory(releaseIssue?.releaseIssueCategory) }}</strong>
          <mat-icon matTooltip="Change category" (click)="releaseIssue.releaseIssueCategory = undefined;">swap_horiz</mat-icon>
        </div>
      </mat-card-content>
    </mat-card>
    <ng-container *ngIf="releaseIssue?.releaseIssueCategory === undefined">
      <mat-card class="w-100 contrast card-link mat-card-inline-sm" (click)="selectCategory(releaseIssueCategories.Drawing)">
        <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
          <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
            <strong>{{ getCategory(releaseIssueCategories.Drawing) }}</strong>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card class="w-100 contrast card-link mat-card-inline-sm" (click)="selectCategory(releaseIssueCategories.Theming)">
        <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
          <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
            <strong>{{ getCategory(releaseIssueCategories.Theming) }}</strong>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card class="w-100 contrast card-link mat-card-inline-sm" (click)="selectCategory(releaseIssueCategories.Software)">
        <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
          <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row">
            <strong>{{ releaseIssueCategories[releaseIssueCategories.Software] }}</strong>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </ng-container>
  <!-- category selecting -->
  <!-- tags -->
  <ng-container *ngIf="releaseIssueId && releaseIssue?.title && releaseIssue?.description && !isDescriptionEditMode && !isDescriptionEditMode">
    <mat-card *ngIf="releaseIssue?.releaseIssueStatus" class="w-100 contrast mat-card-inline-sm banner-info">
      <mat-card-content fxFlex="100" fxLayout="column" fxLayoutAlign="start start">
        <strong class="text-info">Tags</strong>  
        <tag-picker class="w-100"
              (addTagRequest)="addTag($event)"
              (removeTagRequest)="removeTag($event)"
              [allTags]="tags"
              [assignedTagIds]="getAssignedTagIds(releaseIssue)"
              [resourceType]="resourceTypeEnum"
              [allowAddTag]="false">
          </tag-picker>
      </mat-card-content>
    </mat-card>
  </ng-container>
  <!-- tags -->
  <!-- status selecting -->
  <ng-container *ngIf="releaseIssueId && releaseIssue?.title && releaseIssue?.description && !isDescriptionEditMode && !isDescriptionEditMode">
    <mat-card *ngIf="releaseIssue?.releaseIssueStatus" class="w-100 contrast mat-card-inline-sm banner-info">
      <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
        <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
          <strong class="text-info">{{ releaseIssueStatuses[releaseIssue.releaseIssueStatus] }}</strong>
          <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
            <mat-icon *ngIf="leftStatusChangeAvailable">rotate_left</mat-icon>
            <strong class="link" *ngIf="leftStatusChangeAvailable" (click)="selectStatus(leftStatus)">{{ releaseIssueStatuses[leftStatus] }}</strong>
            <mat-icon *ngIf="leftStatusChangeAvailable && rightStatusChangeAvailable">multiple_stop</mat-icon>
            <strong class="link" *ngIf="rightStatusChangeAvailable" (click)="selectStatus(rightStatus)">{{ releaseIssueStatuses[rightStatus] }}</strong>
            <mat-icon *ngIf="rightStatusChangeAvailable">rotate_right</mat-icon>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>
  <!-- status selecting -->
  <!-- assign user -->
  <ng-container *ngIf="releaseIssue?.title && releaseIssue?.description && releaseIssue?.releaseIssuePriority && !isDescriptionEditMode && !isDescriptionEditMode">
    <div *ngIf="!isAssignUserMode">
      <mat-card class="w-100 contrast mat-card-inline-sm banner-info" [class.banner-incomplete]="!releaseIssue?.assignedToName">
        <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
          <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
            <small *ngIf="releaseIssue?.assignedToName" class="text-info">{{ releaseIssue.assignedToName }}</small>
            <small *ngIf="!releaseIssue?.assignedToName" matTooltip="Edit Title" (click)="isAssignUserMode = true">Unassigned</small>
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="3px">
              <mat-icon matTooltip="Assign To Me" (click)="assignToMe()">assignment_ind</mat-icon>
              <mat-icon *ngIf="filteredUsers && filteredUsers.length > 0" matTooltip="Edit Assignee" (click)="isAssignUserMode = true">edit</mat-icon>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <ng-container *ngIf="isAssignUserMode" #assignUserMode>
      <mat-card class="contrast mat-card-inline-sm">
        <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
          <mat-form-field>
            <input matInput type="text"
                   [formControl]="searchUsersField"
                   (keyup)="doUserFilter($event.target.value)"
                   (keyup.esc)="$event.target.value=''; doUserFilter('')"
                   placeholder="Filter users by email">
          </mat-form-field>
        </mat-card-content>
      </mat-card>
      <ng-container *ngFor="let item of filteredUsers; let i=index">
        <mat-card *ngIf="i < 9" class="contrast card-link mat-card-inline-sm" (click)="selectUser(item)" [class.banner-info]="item.selected">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="4px">
              <strong matTooltip="User" [innerHtml]="item.item | encodeHtml | highlight: searchUsersField.value"></strong>
            </div>
          </mat-card-content>
        </mat-card>
      </ng-container>
    </ng-container>
  </ng-container>
  <!-- assign user -->
  <!-- situLINK -->
  <ng-container *ngIf="releaseIssue?.title && releaseIssue?.description && !isDescriptionEditMode">
    <div *ngIf="!isReportedSituLinkEditMode; else reportedSituLinkEditMode">
      <mat-card class="w-100 contrast mat-card-inline-sm banner-info" [class.banner-incomplete]="!releaseIssue?.reportedSituLink">
        <mat-card-content fxLayoutAlign="center center" fxLayout="row wrap" fxLayout.lt-sm="column">
          <div class="m-b-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
              <mat-icon [matTooltip]="releaseIssue?.reportedSituLink" [class.text-info]="releaseIssue?.reportedSituLink">share_location</mat-icon>
              <mat-icon *ngIf="quickViewReportedSituLink" class="link" [matTooltip]="releaseIssue?.reportedSituLink" [class.text-info]="releaseIssue?.reportedSituLink" (click)="toggleQuickViewReportedSituLink(!quickViewReportedSituLink)">expand_less</mat-icon>
              <mat-icon *ngIf="!quickViewReportedSituLink" class="link" [matTooltip]="releaseIssue?.reportedSituLink" [class.text-info]="releaseIssue?.reportedSituLink" (click)="toggleQuickViewReportedSituLink(!quickViewReportedSituLink)">expand_more</mat-icon>
              <small [class.text-info]="releaseIssue?.reportedSituLink">{{ releaseIssue?.reportedSituLink ? 'Issue location set' : 'Issue location not set' }}</small>
            </div>
            <mat-icon matTooltip="Edit Issue Location" (click)="isReportedSituLinkEditMode = true">edit</mat-icon>
          </div>
          <div *ngIf="quickViewReportedSituLink && quickViewReportedSituLinkParams && (quickViewProductName === productNames.Panorama || quickViewProductName === productNames.Facade)" fxFlex="100" fxLayout="row" fxLayoutAlign="center center">
            <div class="quickview">
              <situ-view-readonly *ngIf="quickViewProductName === productNames.Panorama" [routeParams]="quickViewReportedSituLinkParams"></situ-view-readonly>
              <situ-facade-readonly *ngIf="quickViewProductName === productNames.Facade" [routeParams]="quickViewReportedSituLinkParams"></situ-facade-readonly>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <ng-template #reportedSituLinkEditMode>
      <mat-card class="w-100 contrast mat-card-inline-sm banner-incomplete">
        <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
          <div fxFlex="100" fxLayoutAlign="space-between center" fxLayout="row">
            <mat-form-field class="example-full-width" appearance="legacy">
              <mat-label>{{ releaseIssueId ? 'Edit' : 'Add' }} Issue Location</mat-label>
              <input matInput [(ngModel)]="releaseIssue.reportedSituLink" placeholder="Enter issue location" (keydown.enter)="saveIssueLocation()">
              <mat-icon matSuffix matTooltip="Save" (click)="saveIssueLocation()">save</mat-icon>
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-template>
  </ng-container>
  <!-- situLINK -->

  <mat-card *ngIf="confirmedNewIssue &&
    releaseIssue?.title &&
    releaseIssue?.description &&
    releaseIssue?.releaseIssuePriority !== undefined &&
    releaseIssue?.releaseIssueStatus !== undefined &&
    releaseIssue?.releaseIssueCategory !== undefined &&
    !isDescriptionEditMode &&
    !isDescriptionEditMode"
            class="contrast card-link mat-card-inline-sm banner-success" (click)="releaseIssueId ? updateReleaseIssue() : addReleaseIssue()">
    <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
      <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="4px">
        <strong matTooltip="Save release issue">Save release issue</strong>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>
